import React from "react";

// import hoc
import { withErrorBoundary } from "lib/hoc";

import { DigestSetting } from "app/userManagement/modules/generic";

const ProviderDigestSetting = () => {
  return <DigestSetting />;
};

export default withErrorBoundary(ProviderDigestSetting);
